import Box from '@mui/material/Box';
import { useMemo } from 'react';
import { useWatch } from 'react-hook-form';

import { StyledTypography } from 'reservations/base/components/StyledTypography';
import { COMMON_DATETIME_FORMATS } from 'reservations/base/helpers/datetime';
import { getNumberOfGuests } from 'reservations/booking/helpers';
import { FormHeader } from 'reservations/form/components/FormHeader';

const CompleteYourReservation = () => {
  const [date, availability, partySize] = useWatch({
    name: ['date', 'availability', 'partySize']
  });
  const formattedDate = useMemo(
    () => COMMON_DATETIME_FORMATS.dayDateOnly(date),
    [date]
  );

  return (
    <Box>
      <FormHeader />
      <StyledTypography sx={{ mt: '8px' }}>
        {formattedDate} at {availability}
      </StyledTypography>
      <StyledTypography>{getNumberOfGuests(partySize)}</StyledTypography>
    </Box>
  );
};

export default CompleteYourReservation;
